














































import ActivityHistory from "@/model/entity/activity-history/activity-history"
import DetailLog from "./detail-log/DetailLog.vue"
import { activityHistoryService, ActivityHistoryService } from "@/model/service/activity-history/activity-history-service"
import { ExportLogService } from "@/model/service/activity-history/export-log-service"
import Datatable, {DatatableOptions} from "@/components/datatable/Datatable.vue"
import ActivityHistoryLog from "@/model/entity/activity-history/activity-history-log"
import Vue from "vue"
import ACTIVITY_TYPE from "@/model/entity/activity-history/activity-type"
import CollectionRequestExportLog from "@/model/entity/activity-history/collection-request-export-log"
import PacelExportLog from "@/model/entity/activity-history/parcel-export-log"
import AddressExportLog from "@/model/entity/activity-history/address-export-log"

interface ActivityHistoryDetail {
  show: boolean,
  options: DatatableOptions
  activeHistoryService: ActivityHistoryService,
  activityHistoryDetail: ActivityHistoryLog | null,
  loading: boolean
}

const activityHistoryDetail = Vue.extend({
    components: {
      DetailLog,
      Datatable
    },
    props: {
      activity: {
        type: Object as () => ActivityHistory,
        required: true
      }
    },
    data(): ActivityHistoryDetail {
      return {
        show: true,
        activeHistoryService: activityHistoryService,
        options: {},
        activityHistoryDetail: null,
        loading: false
      }
    },
    computed: {
      title() {
        const vm = this as any
        return `${vm.$t("activity-history.details")}
                - ${vm.activity.activityTypeEnum}
                (${vm.activity.id})`
      },
      isSimpleLog() {
        const vm = this as any
        return [
          ACTIVITY_TYPE.LOGIN_AS_OTHER,
          ACTIVITY_TYPE.SESSION_CHANGE,
          ACTIVITY_TYPE.OFFICE_EDIT,
          ACTIVITY_TYPE.PARCEL_RANGE_ADD
        ].includes(vm.activity.activityTypeEnum)
      },
      tableFields() {
        const vm = this as any
        switch (vm.activity.activityTypeEnum) {
          case ACTIVITY_TYPE.COLLECTION_REQUEST_EXPORT:
            return CollectionRequestExportLog.getFieldDescriptionList()
          case ACTIVITY_TYPE.PARCEL_EXPORT:
            return PacelExportLog.getFieldDescriptionList()
          case ACTIVITY_TYPE.ADDRESS_EXPORT:
            return AddressExportLog.getFieldDescriptionList()
        }
      },
      service() {
        const vm = this as any
        return vm.activity.getExportLogService()
      }
    },
    methods: {
        onClose() {
          const vm = this as any
          vm.show = false
          this.$emit("close")
        },
         async download() {
          const vm = this as any
          const service = vm.activity.getExportLogService() as ExportLogService

          const params = new Map()
          params.set("activityHistoryId", vm.activity.id)
          this.loading = true
          const { blob, filename } = await service.exportCsv(params)
          saveAs(blob, filename)
          this.loading = false
        }
    },
    async created() {
      const vm = this as any
      if (vm.isSimpleLog) {
        const { data } = await vm.activeHistoryService.getDetails(vm.activity)
        vm.activityHistoryDetail = data
      }
    }
})

export default activityHistoryDetail
